/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelExcisetaxHistory.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/excisetax-history";

export class AutogenModelExcisetaxHistory<RowType extends ModelRow> extends Endpoint<RowType, RowExcisetaxHistoryFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowExcisetaxHistory extends ModelRow<RowExcisetaxHistoryFields> {
	constructor(values?: Partial<RowExcisetaxHistoryFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowExcisetaxHistoryFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	bill_type: string;
	company_id: string;
	customer_id: string;
	descr: string;
	excisetax_id: string;
	id: string;
	invoice_id: string;
	invoice_no_string: string;
	method: string;
	order_excisetax_id: string;
	order_id: string;
	parent_row_id: string;
	parent_row_type: string;
	post_date: Date;
	rate: number;
	state_id: string;
	tax_date: Date;
	taxable_gross: number;
	taxable_gross_c: string;
	taxable_gross_d: Date;
	taxable_gross_n: number;
	taxable_gross_r: number;
	units: number;
}

